import Propeller from './propeller';

export default Propeller;
